import { useMemo } from 'react';
import { siteInfo } from '@/mocks/homeData';

export default function Hero() {
  const stats = useMemo(() => [
    { label: '累计用户', value: '3800万+', icon: 'ri-user-heart-line' },
    { label: '超清内容', value: '12万+部', icon: 'ri-movie-line' },
    { label: '每日更新', value: '500+部', icon: 'ri-refresh-line' },
  ], []);

  return (
    <section
      id="hero"
      className="relative min-h-[600px] lg:min-h-[700px] flex items-center pt-[72px] overflow-hidden bg-background-50"
    >
      <div
        className="absolute inset-0 opacity-[0.03] pointer-events-none"
        style={{
          backgroundImage:
            'radial-gradient(circle at 25% 60%, oklch(0.60 0.23 14 / 0.5) 0%, transparent 50%), radial-gradient(circle at 75% 30%, oklch(0.745 0.195 78 / 0.4) 0%, transparent 50%), radial-gradient(circle at 50% 80%, oklch(0.755 0.125 35 / 0.3) 0%, transparent 40%)',
        }}
      ></div>

      <div className="w-full px-4 md:px-6 lg:px-10 relative z-10">
        <div className="flex flex-col lg:flex-row items-center gap-8 lg:gap-12 xl:gap-16">
          <div className="flex-1 w-full lg:max-w-[55%] xl:max-w-[50%] pt-6 lg:pt-0">
            <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-primary-100 text-primary-700 text-xs font-medium mb-5">
              <i className="ri-sparkling-line"></i>
              <span>蜜桃视频 · 桃子视频 · 苹果视频 · 榴莲视频 · 芒果视频</span>
            </div>

            <h1 className="text-3xl sm:text-4xl lg:text-5xl xl:text-6xl font-heading font-bold text-foreground-950 leading-tight mb-4">
              糖心视频
              <span className="block text-primary-600">
                甜蜜水果品牌 · 超清在线观影平台
              </span>
            </h1>

            <p className="text-lg md:text-xl text-foreground-600 font-medium mb-3">
              {siteInfo.slogan}
            </p>

            <p className="text-sm md:text-base text-foreground-500 leading-relaxed mb-6 max-w-2xl">
              糖心视频汇聚蜜桃视频、桃子视频、苹果视频、榴莲视频、芒果视频等甜蜜水果品牌，
              致力于打造超清画质与极速播放的在线观影平台。覆盖电影、剧集、综艺、动漫、纪录片全品类，
              每日更新500+部新鲜内容，12万+部超清影片免费观看。无论你是追剧党还是电影迷，
              都能在这里找到属于自己的甜蜜观影时光。
            </p>

            <div className="flex flex-wrap items-center gap-4 sm:gap-6 mb-7">
              {stats.map((stat) => (
                <div key={stat.label} className="flex items-center gap-2">
                  <div className="w-8 h-8 rounded-full bg-accent-100 flex items-center justify-center flex-shrink-0">
                    <i className={`${stat.icon} text-accent-600 text-sm`}></i>
                  </div>
                  <div>
                    <div className="text-lg md:text-xl font-bold text-foreground-900 leading-tight">
                      {stat.value}
                    </div>
                    <div className="text-xs text-foreground-500 whitespace-nowrap">
                      {stat.label}
                    </div>
                  </div>
                </div>
              ))}
            </div>

            <div className="flex flex-col sm:flex-row items-stretch sm:items-center gap-3">
              <a
                href="#ranking"
                className="px-7 py-3 rounded-full bg-primary-500 text-white font-semibold text-sm hover:bg-primary-600 transition-colors text-center whitespace-nowrap cursor-pointer"
              >
                探索热门榜单
              </a>
              <a
                href="#features"
                className="px-7 py-3 rounded-full border-2 border-primary-200 text-primary-700 font-semibold text-sm hover:bg-primary-50 transition-colors text-center whitespace-nowrap cursor-pointer"
              >
                了解平台特色
              </a>
            </div>
          </div>

          <div className="flex-1 w-full lg:max-w-[45%] xl:max-w-[50%] flex justify-center lg:justify-end">
            <div className="relative w-full max-w-[500px] aspect-[4/3] lg:aspect-[5/4] rounded-2xl overflow-hidden bg-gradient-to-br from-primary-100 via-secondary-100 to-accent-100">
              <img
                src="https://readdy.ai/api/search-image?query=A%20warm%20artistic%20abstract%20composition%20with%20soft%20overlapping%20translucent%20fruit%20shapes%20like%20peach%20mango%20and%20apple%20in%20coral%20pink%20golden%20amber%20and%20soft%20peach%20tones%20floating%20on%20a%20clean%20cream%20background%20with%20gentle%20gradient%20light%20rays%20modern%20minimal%20editorial%20style%20with%20smooth%20textures%20and%20elegant%20atmosphere%20suggesting%20video%20streaming%20and%20entertainment&width=1000&height=800&seq=hero-main-visual-tangxin&orientation=landscape"
                alt="糖心视频 - 甜蜜水果品牌超清在线观影平台主视觉"
                className="w-full h-full object-cover"
                onError={(e) => {
                  const target = e.currentTarget;
                  target.style.display = 'none';
                }}
              />
              <div className="absolute inset-0 bg-gradient-to-tr from-primary-500/10 via-transparent to-accent-500/10 pointer-events-none"></div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}